import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DeleteIncidentIssueDocumentInput,
  DeleteIncidentIssueDocumentBulkResponse,
  MutationDeleteIncidentIssueDocumentBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteIncidentIssueDocument } from '@/features/IncidentHistory/api/queries/DeleteIncidentIssueDocument';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteIncidentIssueDocumentInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteIncidentIssueDocumentBulkResponse>;
}

// DeleteIncidentIssueDocument Service
export const { deleteIncidentIssueDocument, useDeleteIncidentIssueDocument } = ((): {
  deleteIncidentIssueDocument: ServiceMethod;
  useDeleteIncidentIssueDocument: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteIncidentIssueDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (
        payload?: DeleteIncidentIssueDocumentInput[],
        options?: ConnectionOptions
      ): Promise<DeleteIncidentIssueDocumentBulkResponse> => {
        const args: MutationDeleteIncidentIssueDocumentBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteIncidentIssueDocumentBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteIncidentIssueDocumentBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteIncidentIssueDocument: fetch,
    useDeleteIncidentIssueDocument: useService,
  };
})();
